import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import Tooltip from '@mui/material/Tooltip';

import { analytics } from 'analytics';
import { openNotificationCenter, selectIsCenterOpen, selectUnseenCount } from 'redux/slices/notifications.slice';

import { StyledBellButton, StyledBadge } from './NotificationBell.styles';

interface NotificationBellProps {
  className?: string;
  collapsed?: boolean;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ className = '', collapsed = false }) => {
  const dispatch = useDispatch();

  const unseenCount = useSelector(selectUnseenCount);

  const isCenterOpen = useSelector(selectIsCenterOpen);

  const handleClick = (): void => {
    analytics.captureNotificationCenterToggled({ action: 'open' });
    dispatch(openNotificationCenter());
  };

  // The badge tracks arrivals since the center was last opened, independently from read state.
  const showBadge = unseenCount > 0 && !isCenterOpen;

  const bellContent = (
    <StyledBellButton onClick={handleClick} className={className} aria-label="Centro de notificaciones">
      <StyledBadge badgeContent={showBadge ? unseenCount : 0} max={99} invisible={!showBadge}>
        <NotificationsNoneOutlinedIcon
          sx={{
            fontSize: '1.2rem',
          }}
        />
      </StyledBadge>
    </StyledBellButton>
  );

  if (collapsed) {
    return (
      <Tooltip title="Notificaciones" placement="right" arrow>
        {bellContent}
      </Tooltip>
    );
  }

  return bellContent;
};

export default NotificationBell;
